import type { VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';
import { cn } from '@savvy-kit/lib/utils';

import { Button } from '../button/button';
import { Spinner } from '../spinner/spinner';

export type IconButtonProps = ComponentProps<'button'> &
  Omit<VariantProps<typeof Button>, 'size'> & {
    size?: 'xs' | 'sm' | 'default' | 'lg';
    variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost';
  };

function IconButton({
  className,
  size = 'default',
  isLoading = false,
  disabled = false,
  children,
  ...props
}: IconButtonProps) {
  const sizeClasses = {
    xs: 'size-6',
    sm: 'size-8',
    default: 'size-10',
    lg: 'size-12',
  };

  return (
    <Button
      disabled={disabled || isLoading}
      className={cn(
        sizeClasses[size],
        className,
        isLoading && '[&>svg:not(:first-of-type)]:hidden',
        !isLoading && '[&>svg:first-of-type]:hidden',
      )}
      {...props}
    >
      <Spinner />
      {children}
    </Button>
  );
}

export default IconButton;
